export const FORECASTING_ACCESS = 'forecasting-access';
export const FORECASTING_EDIT = 'forecasting-edit';
export const GOAL_FORECAST_VIEW_ALL = 'goal-forecast-view-all';
export const GOAL_FORECAST_VIEW_TEAM = 'goal-forecast-view-team';
export const GOAL_FORECAST_EDIT_TEAM = 'goal-forecast-edit-team';
export const GOAL_FORECAST_EDIT_OWNED = 'goal-forecast-edit-owned';
export const GOAL_FORECAST_EDIT_ALL = 'goal-forecast-edit-all';
export const TEAMS_HIERARCHY = 'teams-advanced-modeling-access';
export const SUPER_ADMIN = 'super-admin';
export const PARTNER_ADMIN = 'partner-admin';
export const DEAL_TAGS_ACCESS = 'crm-pipelines-object-label-access';